import './style/style.sass';

import React from 'react';

import { ImageAndDescr } from '../share/ImageAndDescr';
import { QuestionMark } from '../share/QuestionMark';

const ACTIVE = 'clicked'

export class AttributeMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      marginBottom: ''
    }

    this.onClick = this.onClick.bind(this)
  }

  onClick() {

    let mm = ''
    let isActive = false
    if (!this.props.attr.isActive) {

      this.parent.classList.add(ACTIVE)

      const pt = window.getComputedStyle(this.hint, null).getPropertyValue('padding-top')
      const h = this.hint.getBoundingClientRect().height

      const calcH = 'calc(' + h + 'px + ' + pt + ' / 2)'
      this.parent.style.marginBottom = calcH
      mm = calcH
      isActive = true
    } else {
      this.parent.classList.remove(ACTIVE)
      this.parent.style.marginBottom = ''
      mm = ''
      isActive = false
    }

    // this.setState(() => ({ marginBottom: mm }))

    this.props.toggleDescription({
      attributHint: this.hint,
      attr: { ...this.props.attr, isActive: isActive, marginBottom: mm }
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.marginBottom !== this.state.marginBottom) {
      return true;
    }
    return false
  }

  render() {
    const { name, short_name, isDisabled, marginBottom } = this.props.attr;

    // const style = {
    //   marginBottom: (this.props.attr && this.parent && this.props.attr.isActive)
    //     ? this.parent.style.marginBottom
    //     : ''
    // };
    const style = {
      // marginBottom: this.state.marginBottom
      marginBottom: marginBottom
    };

    // console.log(this.state)


    const className = "attribute " + (this.props.attr.isActive ? ACTIVE : '')

    return (
      <div
        ref={parent => this.parent = parent}
        className={className}
        style={style}
        onClick={this.onClick}
      >
        <QuestionMark name={name} isDisabled={isDisabled} />
        <div
          ref={hint => this.hint = hint}
          className="attribute-hint"
        >
          <ImageAndDescr attr={this.props.attr} />
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/impl/AttributeMobile/AttributeMobile.jsx